<template>
	<header>
			<slot v-if="!isMobile">
				<div class="top">
							<div class="container">
								<div class="row">
									<div class="row-inc">
										<div class="links">
											<li>
												<router-link :to="{ name: 'Affiliate'}" class="button secondary">
													Ortaklık
												</router-link>
											</li>
										</div>
										<div class="info">
											<!--
											<a  v-if="user" class="button secondary bonus-request-btn" data-title="Bonus Al" @click="bonus_modal = true;type = 'bonus'" href="javascript:;">
												Bonus Al
											</a>-->
											<a  v-if="user" class="button secondary discount-request-btn" data-title="Discount Al" @click="bonus_modal = true;type = 'discount'" href="javascript:;">
												Discount Al</a>
											<div class="bonus-modal" v-if="configSpesific.autoBonus">
												<Modal :isVisible="bonus_modal">
													<template slot="content">
														<div class="close-btn button primary" @click="bonus_modal = false;type = ''">
																<svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
														</div>
														<component is="RequestPage" :propType="type" />
													</template>
												</Modal>
											</div>
											<promoCode v-if="user"></promoCode>
											<SocialMedia></SocialMedia>
											<router-link :to="{ name: 'Promotions' }" type="button" class="button primary promo-btn">
												<img src="@/assets/images/common/icons/bonus.gif">
												Promosyonlar</router-link>
											<div class="dropdown">
												<button class="button" style="text-transform:uppercase" @click="languageDropdown = !languageDropdown">
															<img :src="require('@/assets/images/lang/' + $i18n.locale + '.jpg')">
															{{ $i18n.locale }}
															<svg :style="languageDropdown ? 'transform: rotate(180deg);' : ''" x="0px" y="0px" viewBox="0 0 491.996 491.996" style="enable-background:new 0 0 491.996 491.996;" xml:space="preserve"> <g> <g> <path d="M484.132,124.986l-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86c-7.208,0-13.964,2.792-19.036,7.86l-183.84,183.848    L62.056,108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968,2.788-19.036,7.856l-16.12,16.128    c-10.496,10.488-10.496,27.572,0,38.06l219.136,219.924c5.064,5.064,11.812,8.632,19.084,8.632h0.084    c7.212,0,13.96-3.572,19.024-8.632l218.932-219.328c5.072-5.064,7.856-12.016,7.864-19.224    C491.996,136.902,489.204,130.046,484.132,124.986z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
												</button>
												<transition name="slide-fade">
														<div class="dropdown-menu" v-if="languageDropdown">
																<ul>
																	<li v-for="(item, key) in lang" :key="key" v-show="$i18n.locale != item"><a @click="$i18n.locale = item; $store.dispatch('language/setLanguage', item)" href="javascript:;">
																		<img :src="require('@/assets/images/lang/' + item + '.jpg')"> {{ item | ucFirst }}</a>
																	</li>
																</ul>
														</div>
												</transition>
											</div>
											<!-- <div class="download" style="margin-left:10px">
												<button class="button primary">
													<svg viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"> <g> <polygon points="260.313,109.424 229.688,109.424 229.688,213.283 182.774,213.283 245,296.902 307.226,213.283 260.313,213.283 "/> <path d="M22.969,362.717h183.75v52.951h-69.863v30.625h216.289v-30.625h-69.863v-52.951h183.75 c12.633,0,22.969-10.336,22.969-22.969V66.676c0-12.633-10.336-22.969-22.969-22.969H22.969C10.336,43.707,0,54.043,0,66.676 v273.073C0,352.381,10.336,362.717,22.969,362.717z M30.625,74.332h428.75v257.76H30.625V74.332z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
													Masaüstüne İndir</button>
											</div> -->
										</div>
									</div>
								</div>
							</div>
				</div>
				<div class="center">
					<div class="container">
						<div class="row">
							<div class="row-inc">
									<Logo/>
									<div class="right">
										<a target="_blank" class="call-btn" v-if="!isMobile" href="https://forms.gle/zcFr4fVKNBQyc1Ax9">
											Beni Ara
										</a>
										<slot v-if="!user">
											<DesktopGuest/>
										</slot>
										<slot v-else>
											<DesktopUser/>
										</slot>
									</div>
									<!-- <Menu/> -->
									<!-- <div class="user">
											<DesktopGuest :pages="pages" v-if="!user"/>
											<DesktopUser :pages="pages" v-if="user"/>
									</div> -->
							</div>
						</div>
					</div>
				</div>
				<div class="bottom">
					<div class="container">
						<div class="row">
							<div class="row-inc">
								<Menu/>
							</div>
						</div>
					</div>
				</div>
			</slot>
			<slot v-else>
				<div class="top-m">
					<div class="menu">
						<a href="javascript:;" class="nav" v-if="activePanel != 'left-panel'" @click="triggerPanel('left-panel')">
							<svg aria-hidden="true" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>
						</a>
						<a href="javascript:;" class="nav" v-if="activePanel == 'left-panel'" @click="triggerPanel('')">
							<svg x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve"> <path d="M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4  c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1  c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z"/> </svg>
						</a>
					</div>
					<Logo @click.native="triggerPanel('')"/>
					<div class="user">
						<div class="icon" v-if="user">
								<a href="javascript:;" class="nav" @click="triggerPanel('right-panel')">
									<svg xmlns="http://www.w3.org/2000/svg" v-if="activePanel != 'right-panel'" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,74.667    c67.635,0,122.667,55.031,122.667,122.667S323.635,320,256,320s-122.667-55.031-122.667-122.667S188.365,74.667,256,74.667z     M256,469.333c-69.707,0-131.52-33.755-170.473-85.615c42.676-20.534,103.621-42.385,170.473-42.385    c66.857,0,127.807,21.854,170.474,42.383C387.521,435.577,325.708,469.333,256,469.333z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
								</a>
								<a href="javascript:;" class="nav" v-if="activePanel == 'right-panel'" @click="triggerPanel('')">
									<svg x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve"> <path d="M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4  c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1  c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z"/> </svg>
								</a>
						</div>
						<div class="icon" v-if="!user">
								<router-link :to="{ name: 'Login'}" class="nav">
									<svg x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,74.667    c67.635,0,122.667,55.031,122.667,122.667S323.635,320,256,320s-122.667-55.031-122.667-122.667S188.365,74.667,256,74.667z     M256,469.333c-69.707,0-131.52-33.755-170.473-85.615c42.676-20.534,103.621-42.385,170.473-42.385    c66.857,0,127.807,21.854,170.474,42.383C387.521,435.577,325.708,469.333,256,469.333z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
								</router-link>
						</div>
					</div>
				</div>
				<div class="guest" v-if='!user'>
					<router-link class="button secondary" :to="{ name : 'Login' }">Giriş Yap</router-link>
					<router-link class="button primary" :to="{ name : 'Register' }">Kayıt Ol</router-link>
				</div>
			</slot>
	</header>
</template>
<script>
	import Menu from './Header/Menu'
	import Logo from './Header/Logo'
	import promoCode from './Header/promoCode'
	import DesktopGuest from './Header/DesktopGuest'
	import SocialMedia from './SocialMedia'
	import DesktopUser from './Header/DesktopUser'
	import RequestPage from './Header/Request.vue'	
	export default{
		props:['activePanel'],
		data(){
			return{
				isLogin: false,
				date : this.$moment(new Date()).format('HH:mm:ss'),
				languageDropdown : false,
				type: '',
				bonus_modal: false,
			}
		},
		components:{
			Menu,
			Logo,
			promoCode,
			DesktopGuest,
    		RequestPage,
			SocialMedia,
			DesktopUser
		},
		computed:{
			configSpesific(){ 
			return this.$store.getters['special/getConfigSpesific']
			},
			social(){
				return this.$store.getters.getClientContent;
			},
			pages(){
				return _.filter(this.$store.getters.getClientPages, {header: 1});
			},
			lang(){
				return this.$store.getters.getLanguages;
			},
			user(){
			return this.$user();
			}
		},
    mounted(){
      setInterval(() => {
        this.date = this.$moment(new Date()).format('HH:mm:ss');
      }, 1000);
    },
		created(){
			
		},
		methods:{
				triggerPanel(panel){
					this.$emit('triggerPanel', panel)
				}
		}
	}
</script>